export default __webpack_public_path__ + "static/media/cannoli.d151f0f8.jpg";